module.exports = __webpack_public_path__ + "img/NETWORK URL.dc464d13.svg";